import React from "react";
import { Route, Redirect } from "react-router-dom";
export const PrivateRoute = ({
  component: Component = null,
  render: Render = null,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      return localStorage.accessToken ? (
        Render ? (
          Render(props) //execute function with assigned props
        ) : Component ? (
          <Component {...props} /> // redner the assigned component
        ) : null
      ) : (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: props.location }
          }}
        />
      );
    }}
  />
);
